import { SvgIcon } from "@material-ui/core";
import React from "react";

const MsgSend = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <svg
        id="send_black_24dp"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          id="Path_6022"
          data-name="Path 6022"
          d="M0,0H24V24H0Z"
          fill="none"
        />
        <path
          id="Path_6023"
          data-name="Path 6023"
          d="M2.01,21,23,12,2.01,3,2,10l15,2L2,14Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default MsgSend;
